import { MutationTree } from 'vuex';

export const state = () => ({
  id: null,
  query: {
    where: {
      reportType: 'ONCORISK'
    },
    sort: {
      bioinformaticPanel: 'DESC'
    },
    offset: 0,
    limit: 10
  },
  table: {
    footer: {
      'items-per-page-options': [10, 25, 50, 100],
      'show-current-page': true,
      'show-first-last-page': true
    },
    filter: {
      keyword: ''
    },
    options: {
      page: 1,
      itemsPerPage: 10,
      sortBy: [],
      sortDesc: [false],
      groupBy: [],
      groupDesc: [],
      multiSort: false,
      mustSort: true
    }
  }
});

export type OncoRiskMapperState = ReturnType<typeof state>;

export const mutations: MutationTree<OncoRiskMapperState> = {
  changeId: (state, id) => (state.id = id),
  changeQuery: (state, query) => Object.assign(state.query, query),
  changeTableFilter: (state, filter) => {
    Object.assign(state.table, { filter });
    Object.assign(state.query, {
      where: {
        keyword: filter.keyword,
        reportType: 'ONCORISK'
      }
    });
  },
  changeTableOptions: (state, options) => {
    Object.assign(state.table, { options });
    Object.assign(state.query, {
      sort: options.sortDesc[0] ? `-${options.sortBy[0]}` : options.sortBy[0],
      limit: options.itemsPerPage,
      offset: (options.page - 1) * options.itemsPerPage
    });
  }
};
